module.exports = __webpack_public_path__ + "img/doctor-computer-DESKTOP.072b65b6.jpg";